module.exports = __webpack_public_path__ + "img/logo_mini2.338052a3.png";